'use client';

import { useRouter } from 'next/navigation';
import { ChevronDown } from 'lucide-react';
import { formatDisplayText } from '../../../utils/textUtils';

interface Exam {
  _id: string;
  exam_name: string;
}

interface ExamFilterProps {
  topicName: string;
  exams: Exam[];
  selectedExam: string;
  search?: string;
}

export default function ExamFilter({ topicName, exams, selectedExam, search }: ExamFilterProps) {
  const router = useRouter();
  
  const handleExamChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const examValue = e.target.value;
    const params = new URLSearchParams();
    if (examValue) params.set('exam', examValue);
    if (search) params.set('search', search);
    router.push(`/practice/${topicName}${params.toString() ? `?${params.toString()}` : ''}`);
  };

  return (
    <div className="relative">
      <div className="relative">
        <select
          value={selectedExam}
          onChange={handleExamChange}
          className="study-search study-input rounded-lg px-4 py-2.5 min-w-[180px] text-left text-sm appearance-none cursor-pointer transition-colors pr-8 focus:outline-none"
          aria-label="Filter subtopics by exam type"
        >
          <option value="">All Exams</option>
          {exams.map((exam) => (
            <option key={exam._id} value={exam.exam_name}>
              {formatDisplayText(exam.exam_name).toUpperCase()}
            </option>
          ))}
        </select>
        <ChevronDown className="study-muted absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 pointer-events-none" aria-hidden="true" />
      </div>
    </div>
  );
}

